import tinycolor from 'tinycolor2';
import echarts from 'echarts/lib/echarts';

export default {
  data: () => ({
    chartColor: {
      merge: '#d78407',
      axisLabel: '#6B717D',
      splitArea: '#666',
    },
  }),
  computed: {
    isDark() {
      return this.$vuetify.theme.isDark;
    },
  },
  methods: {
    getGrayColor(color, dark, bright) {
      const tc = tinycolor(color).greyscale();
      return this.isDark ? tc.darken(dark || 10).toString() : tc.brighten(bright || 30).toString(); // eslint-disable-line
    },
    getThemeColor(color, dark, bright) {
      const tc = tinycolor(color);
      return this.isDark ? tc.darken(dark || 30).toString() : tc.brighten(bright || 30).toString(); // eslint-disable-line
    },
    getReverseThemeColor(color, dark, bright) {
      const tc = tinycolor(color);
      return this.isDark ? tc.brighten(bright || 30).toString() : tc.darken(dark || 30).toString(); // eslint-disable-line
    },
    areaStyleGradation(color) {
      const tc = tinycolor(color);
      return {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: tc.brighten(30).toString(), // eslint-disable-line
            },
            {
              offset: 1,
              color: tc.darken(20).toString(), // eslint-disable-line
            },
          ],
          global: false, // false by default
        },
      };
    },
    areaStyleLinearGradient(color, dark, light) {
      const method = this.isDark ? 'darken' : 'brighten';
      const rate = this.isDark ? dark || 20 : light || 30;
      const tc = tinycolor(color);
      return {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color },
          { offset: 1, color: tc[method](rate).toString() }, // eslint-disable-line
        ]),
      };
    },
    areaStyleSpinLinearGradient(color, dark, light) {
      const method = this.isDark ? 'darken' : 'brighten';
      const rate = this.isDark ? dark || 20 : light || 30;
      const spin = this.isDark ? 80 : -130;
      const tc = tinycolor(color);
      return {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color },
          {
            offset: 1,
            color: tc[method](rate)
              .spin(spin)
              .toString(),
          }, // eslint-disable-line
        ]),
      };
    },
    circle(color, size) {
      size = size || 10;
      return `<span style="border-radius:50%;display:inline-block;background-color:${color};height:${size}px;width:${size}px;margin-right:5px;"></span>`;
    },
    showLoading(chart) {
      this.$nextTick(() => {
        if (chart === undefined) {
          chart = this.$refs.chart.$refs.chart.chart;
        }
        chart.showLoading('default', {
          text: 'loading...',
          textColor: '#fff',
          fontSize: '12px',
          maskColor: 'rgba(26, 26, 26, 0.3)',
          showSpinner: true,
          color: '#f57c00',
          spinnerRadius: 10,
          lineWidth: 4,
          zlevel: 0,
        });
      });
    },
    hideLoading(chart) {
      this.$nextTick(() => {
        if (chart === undefined) {
          chart = this.$refs.chart.$refs.chart.chart;
        }
        chart.hideLoading();
      });
    },
    getChart() {
      return this.$refs.chart.$refs.chart.chart;
    },
  },
};
